import {
  capitalizeFirstLetterAndSplitByUnderscore,
  isObjectEmpty,
} from "./functions";

/**
 *
 * @param {Record<string|number, any> | undefined} obj
 * @param {string[] | number[]} requiredKeys
 * @param {() => {}|undefined} callback
 * @returns {{hasErrors: boolean, errors: Record<string, string>}|Function}
 * @description Check an object for empty value and return errors
 */
const validateObject = (obj, requiredKeys, callback = undefined) => {
  if (!requiredKeys || !requiredKeys?.length) {
    requiredKeys = Object.keys(obj);
  }
  const modifiedObj = {};
  let errors = {};
  Object.entries(obj)
    .filter(([key]) => requiredKeys.includes(key))
    .map(([key, value]) => {
      return Object.assign(modifiedObj, { [key]: value });
    });
  const isValidationFailed = isObjectEmpty(modifiedObj)
    ? false
    : Object.entries(modifiedObj).every(([key, value]) => {
        let message;
        const modKey = capitalizeFirstLetterAndSplitByUnderscore(key)
          .split("_")
          .join(" ");
        if (typeof value === "object" && !Array.isArray(value)) {
          value = !isObjectEmpty(value);
        }
        if (Array.isArray(value)) {
          value = value.length;
          message = `Must select at least one ${modKey}`;
        }
        if (!value) {
          errors = { ...errors, [key]: message ?? `${modKey} is required` };
        }
        return !!value;
      });
  if (callback) {
    return callback();
  }
  return { hasErrors: !isValidationFailed, errors };
};

export { validateObject };
